import axios from 'axios'
import {getToken, deleteToken, getLocalStorage, saveLocalStorage} from '../utils/webCache'
import {deleteObjNullKey, getSign} from '../utils/customUtils'

// 设置响应时间
axios.defaults.timeout = 5000

// 设置全局请求头
// axios.defaults.headers['timestamp'] = Date.parse(new Date()) / 1000
axios.defaults.headers['touchid'] = 'h5'
axios.defaults.headers['device'] = 'h5'

// 设置 api 请求 地址
axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/'

// Api签名key
let signKey = 'base64:qC93ZPHeTNxh2SwB/DeOSb0zUwhHWHWHiU61ZDAPvdnOjkOYE='

/**
 * 请求拦截器
 */
axios.interceptors.request.use((config) => {
  // config.headers['token'] = 'fe9b23577cd39340.5cb2f40d20cb49a1df3abde05822ae49' // todo
  // config.headers['token'] = 'f8a6e779b6b6e69b.b228eeb72b7a36a41dc55bc7a85dc028' // todo
  config.headers['timestamp'] = Date.parse(new Date()) / 1000 + Number(getLocalStorage('time'))

  // 签名参数
  let signParams = {
    device: config.headers['device'],
    timestamp: config.headers['timestamp'],
    touchid: config.headers['touchid']
  }

  // 设置token
  if (getToken()) {
    signParams.token = config.headers['token'] = getToken()
  }
  // 拼接 请求参数 到签名参数
  let joinSignParams = Object.assign(signParams, deleteObjNullKey(Object.assign(config.body || {}, config.params || {}, config.data || {})))
  // 设置签名
  config.url = config.url + '?sign=' + getSign(joinSignParams, signKey) + '&timestamp=' + config.headers['timestamp']

  return config
}, (error) => {
  console.log('request error')
  return Promise.reject(error)
})

/**
 * 响应拦截器
 */
axios.interceptors.response.use((response) => {
  console.log()
  let data = response.data

  // 无token 时处理
  if (data.code === 403 || data.code === 401) {
    // 清除本地缓存的token
    deleteToken()
    // window.location.reload()
  }

  if (data.code === 400 && data.msg === '请校正您的系统时间') {
    saveLocalStorage('time', null)
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  return data
}, (error) => {
  console.log('network error')
  return Promise.reject(error)
})

/**
 * 获取服务器时间戳
 *
 * @returns {Promise<unknown>}
 */
// eslint-disable-next-line no-unused-vars
function getAppletTime () {
  return new Promise((resolve, reject) => {
    axios.get('api/v1/appInit/time').then(response => {
      if (response.code === 200 && response.data.time) {
        const localTime = Date.parse(new Date()) / 1000

        const timeDiff = response.data.time - localTime

        saveLocalStorage('time', timeDiff)
      }
      resolve(true)
    })
  })
}

/**
 * GET 请求
 *
 * @param url 请求地址
 * @param params 参数
 *
 * @returns {Promise<any>} 返回一个异步对象
 */
export async function getRequest (url, params) {
  let getTimeRes
  getLocalStorage('time') ? getTimeRes = true : getTimeRes = await getAppletTime()
  if (getTimeRes) {
    return new Promise((resolve, reject) => {
      axios.get(url, {params: params}).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

/**
 * POST 请求
 *
 * @param url 请求地址
 * @param params 参数
 *
 * @returns {Promise<any>} 返回一个异步对象
 */

export async function postRequest (url, params) {
  let getTimeRes
  getLocalStorage('time') ? getTimeRes = true : getTimeRes = await getAppletTime()
  if (getTimeRes) {
    // 序列化数据
    let data = params
    // let data = qs.stringify(params)
    return new Promise((resolve, reject) => {
      axios.post(url, data).then(response => {
        resolve(response)
      }, error => {
        reject(error)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

/**
 * PUT 请求
 *
 * @param url
 * @param params
 *
 * @returns {Promise<any>}
 */
export function putRequest (url, params) {
  let data = params
  let requestUrl = ''
  if (params.id) {
    requestUrl = url + '/' + params.id
  } else {
    requestUrl = url
  }
  console.log(params)
  return new Promise((resolve, reject) => {
    axios.put(requestUrl, data).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * DELETE 请求
 *
 * @param url url 地址
 * @param id 删除数据的 主键id
 *
 * @returns {Promise<any>}
 */
export function deleteRequest (url, id) {
  let requestUrl = url + '/' + id
  return new Promise((resolve, reject) => {
    axios.delete(requestUrl).then(response => {
      resolve(response)
    }, error => {
      reject(error)
    }).catch(error => {
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/request.js